import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


export class ZrDropdownSelectionComponent implements OnInit {
   options: any[] = [];
   position?: string = 'center';
   type?: string = 'btn';
   dropText?: string;
   icon?: string = 'la la-ellipsis-h';
   iconClass?: string;
   btnColor?: string = 'btn-secondary';
   trigger?: string = 'click';
   separateCharacter?: string = '/';
   multiselect?: boolean = false;
   selectParent?: boolean = false;

   selected = new EventEmitter();
   remove = new EventEmitter();

  openDropdown: boolean = true;
  isEmpty: boolean = true;
  recordBtnText: any;
  multiselectArray: any[] = [];
  radioSelect: any;

  constructor() { };

  ngOnInit() {
    this.recordBtnText = this.dropText;
  };

  openChildren(row: any) {
    if (row.children) {
      row.childrenOpen = true;
    }
  };

  closeChildren(row: any) {
    if (row.childrenOpen) {
      row.childrenOpen = false;
    }
  };

  toggleDropdown() {
    if (!this.openDropdown) {
      this.openDropdown = true;
    };
  };

  onSelected(event: any, item: any) {
    // 多选或者禁用时取消事件冒泡（即关闭弹窗事件）
    if (this.multiselect || item.disabled) {
      event.stopPropagation();
    };

    // 禁用时返回
    if (item.disabled) {
      return;
    };

    // 按钮型多选时
    if (this.multiselect && this.type === 'btn') {
      // 为空时
      if (this.isEmpty) {
        // 有子集时
        if (item.children) {
          // 不能选中父级
          if (!this.selectParent) {
            return;
          }
        }
        this.dropText = `${item.text}`;
        this.multiselectArray.push(item);
        this.selected.emit(this.multiselectArray);
        this.isEmpty = false;
      } else {
        // 不为空时，查看是否已经选择过，是则返回
        for (const m of this.multiselectArray) {
          if (item.text === m.text) {
            event.stopPropagation();
            return;
          }
        };
        if (item.children) {
          // 不能选中父级
          if (!this.selectParent) {
            return;
          }
        }
        this.dropText += `${this.separateCharacter} ${item.text}`;
        this.multiselectArray.push(item);
        this.selected.emit(this.multiselectArray);
      }
    } else if (this.type === 'btn') { // 按钮型单选时
      this.multiselectArray = [];
      if (item.children) {
        if (!this.selectParent) {
          event.stopPropagation();
          return;
        }
      }
      this.multiselectArray.push(item);
      this.dropText = `${item.text}`;
      this.selected.emit(this.multiselectArray);
      this.openDropdown = true;
    } else {  // icon型时
      this.multiselectArray = [];
      if (item.children) {
        if (!this.selectParent) {
          event.stopPropagation();
          return;
        }
      }
      this.multiselectArray.push(item);
      this.selected.emit(this.multiselectArray);
      this.openDropdown = true;
    }
  };

  removeValue(): void {
    this.dropText = this.recordBtnText;
    this.isEmpty = true;
    this.multiselectArray = [];
    this.remove.emit();
  };
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'zr-dropdown-selection',
  template: `
    <!-- click -->
    <div *ngIf="trigger==='click'" class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-push m-dropdown--align-{{position}}"
      aria-expanded="true">
      <a href="javascript:void(0)" [hidden]="type==='icon'" (click)="openDropdown=!openDropdown" class="m-dropdown__toggle btn {{btnColor}} dropdown-toggle">{{dropText}}</a>
      <a href="javascript:void(0)" [hidden]="type==='btn'" (click)="openDropdown=!openDropdown" class="m-portlet__nav-link m-dropdown__toggle btn m-btn {{iconClass}}">
        <i class="{{icon}}" *ngIf="type==='icon'"></i>
      </a>
      <i class="la la-times-circle-o dropdown-btn-remove-icon" *ngIf="type==='btn'&&!isEmpty&&multiselect" (click)="removeValue()"></i>
      <div [hidden]="openDropdown" (mouseleave)="toggleDropdown()" class="m-dropdown__wrapper">
        <span class="m-dropdown__arrow m-dropdown__arrow--{{position}}"></span>
        <div class="m-dropdown__inner">
          <div class="m-dropdown__body lz-m-dropdown__body">
            <div class="m-dropdown__content">
              <ul class="m-nav lz-m-nav">
                <li class="m-nav__item lz-m-nav__item" *ngFor="let option of options" (click)="onSelected($event,option)" (mouseenter)="openChildren(option)"
                  (mouseleave)="closeChildren(option)">
                  <a class="m-nav__link" [ngClass]="{'m-dropdown__disabled':option.disabled}">
                    <i class="m-nav__link-icon {{option.icon}}" [ngClass]="{'m-dropdown__disabled':option.disabled}"></i>
                    <span class="m-nav__link-text" [ngClass]="{'m-dropdown__disabled':option.disabled}">{{option.text}}</span>
                    <i *ngIf="option.children" class="m-menu__hor-arrow la la-angle-right lz-la-angle-right"></i>
                  </a>
                  <div [hidden]="!option.childrenOpen" class="m-dropdown__wrapper lz-m-dropdown__wrapper" [ngStyle]="{'top':'-18px'}" [style.left]="position==='left'?'112%':position==='right'?'104%':'154%'">
                    <span class="m-dropdown__arrow m-dropdown__arrow--left lz-m-dropdown__arrow--left"></span>
                    <div class="m-dropdown__inner">
                      <div class="m-dropdown__body">
                        <div class="m-dropdown__content">
                          <ul class="m-nav">
                            <li class="m-nav__item" *ngFor="let childrenItem of option.children">
                              <a class="m-nav__link" [ngClass]="{'m-dropdown__disabled':childrenItem.disabled}" (click)="$event.stopPropagation();onSelected($event,childrenItem)">
                                <i class="m-nav__link-icon {{childrenItem.icon}}" [ngClass]="{'m-dropdown__disabled':childrenItem.disabled}"></i>
                                <span class="m-nav__link-text" [ngClass]="{'m-dropdown__disabled':childrenItem.disabled}">{{childrenItem.text}}</span>
                                <i *ngIf="childrenItem.children" class="m-menu__hor-arrow la la-angle-right lz-la-angle-right"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- hover -->
    <div *ngIf="trigger==='hover'" class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-push m-dropdown--align-{{position}}"
      aria-expanded="true">
      <a href="javascript:void(0)" [hidden]="type==='icon'" (mouseenter)="openDropdown=!openDropdown" class="m-dropdown__toggle btn {{btnColor}} dropdown-toggle">{{dropText}}</a>
      <a href="javascript:void(0)" [hidden]="type==='btn'" (mouseenter)="openDropdown=!openDropdown" class="m-portlet__nav-link m-dropdown__toggle btn m-btn {{iconClass}}">
        <i class="{{icon}}" *ngIf="type==='icon'"></i>
      </a>
      <i class="la la-times-circle-o dropdown-btn-remove-icon" *ngIf="type==='btn'&&!isEmpty&&multiselect" (click)="removeValue()"></i>
      <div [hidden]="openDropdown" (mouseleave)="toggleDropdown()" class="m-dropdown__wrapper">
        <span class="m-dropdown__arrow m-dropdown__arrow--{{position}}"></span>
        <div class="m-dropdown__inner">
          <div class="m-dropdown__body lz-m-dropdown__body">
            <div class="m-dropdown__content">
              <ul class="m-nav lz-m-nav">
                <li class="m-nav__item lz-m-nav__item" *ngFor="let option of options" (click)="onSelected($event,option)" (mouseenter)="openChildren(option)"
                  (mouseleave)="closeChildren(option)">
                  <a class="m-nav__link" [ngClass]="{'m-dropdown__disabled':option.disabled}">
                    <i class="m-nav__link-icon {{option.icon}}" [ngClass]="{'m-dropdown__disabled':option.disabled}"></i>
                    <span class="m-nav__link-text" [ngClass]="{'m-dropdown__disabled':option.disabled}">{{option.text}}</span>
                    <i *ngIf="option.children" class="m-menu__hor-arrow la la-angle-right lz-la-angle-right"></i>
                  </a>
                  <div [hidden]="!option.childrenOpen" class="m-dropdown__wrapper lz-m-dropdown__wrapper" [ngStyle]="{'top':'-18px'}" [style.left]="position==='left'?'112%':position==='right'?'104%':'154%'">
                    <span class="m-dropdown__arrow m-dropdown__arrow--left lz-m-dropdown__arrow--left"></span>
                    <div class="m-dropdown__inner">
                      <div class="m-dropdown__body">
                        <div class="m-dropdown__content">
                          <ul class="m-nav">
                            <li class="m-nav__item" *ngFor="let childrenItem of option.children">
                              <a class="m-nav__link" [ngClass]="{'m-dropdown__disabled':childrenItem.disabled}" (click)="$event.stopPropagation();onSelected($event,childrenItem)">
                                <i class="m-nav__link-icon {{childrenItem.icon}}" [ngClass]="{'m-dropdown__disabled':childrenItem.disabled}"></i>
                                <span class="m-nav__link-text" [ngClass]="{'m-dropdown__disabled':childrenItem.disabled}">{{childrenItem.text}}</span>
                                <i *ngIf="childrenItem.children" class="m-menu__hor-arrow la la-angle-right lz-la-angle-right"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>`,
  styles: [
    `
      .m-dropdown .m-dropdown__wrapper {
        display: block;
        width: 245px;
      }

      .m-dropdown__arrow .m-dropdown__arrow--left {
        left: 34px;
        margin-left: 0;
      }

      .m-dropdown__arrow .m-dropdown__arrow--right {
        right: 34px;
        margin-left: 0;
      }

      .m-dropdown__arrow--adjust-right {
        right: 33px;
        left: auto;
      }

      .m-dropdown__arrow--adjust-left {
        left: 33px;
        right: auto;
      }

      .m-dropdown__disabled {
        color: #b4bccc !important;
        cursor: not-allowed !important;
      }

      .dropdown-btn-remove-icon {
        cursor: pointer;
      }

      .lz-m-dropdown__body {
        padding: 0 !important;

        .lz-m-nav {
          padding-top: 20px;
          padding-bottom: 20px;
        }
      }

      .lz-la-angle-right {
        float: right;
        width: 20px;
        font-size: 0.8rem !important;
        color: #b9c1d4;
      }

      .lz-m-nav__item {
        position: relative;
        padding-left: 20px;
        padding-right: 20px;

        .lz-m-dropdown__wrapper {
          position: absolute;
          right: auto;
        }
      }

      .lz-m-dropdown__arrow--left {
        position: absolute;
        top: 28px !important;
        left: -24px !important;
        margin-left: 0 !important;
        transform: rotate(-90deg);
      }
    `
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'options': [{ type: Input },],
'position': [{ type: Input },],
'type': [{ type: Input },],
'dropText': [{ type: Input },],
'icon': [{ type: Input },],
'iconClass': [{ type: Input },],
'btnColor': [{ type: Input },],
'trigger': [{ type: Input },],
'separateCharacter': [{ type: Input },],
'multiselect': [{ type: Input },],
'selectParent': [{ type: Input },],
'selected': [{ type: Output },],
'remove': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
